import { useState, useCallback } from 'react';
import { rolesAPI } from '../services/rolesAPI';

export const useRoles = () => {
  const [roles, setRoles] = useState([]);
  const [estadosTurno, setEstadosTurno] = useState([]);
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const cargarRoles = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const [rolesData, estadosData, menusData] = await Promise.all([
        rolesAPI.getRoles(),
        rolesAPI.getEstadosTurno(),
        rolesAPI.getMenus()
      ]);
      setRoles(rolesData);
      setEstadosTurno(estadosData);
      setMenus(menusData);
    } catch (err) {
      setError('Error al cargar los datos');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const actualizarPermisos = useCallback(async (rolId, estadosPermitidos) => {
    setLoading(true);
    setError('');
    try {
      await rolesAPI.updatePermisos(rolId, estadosPermitidos);
      await cargarRoles();
    } catch (err) {
      setError('Error al actualizar permisos');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  }, [cargarRoles]);

  return {
    roles,
    estadosTurno,
    menus,
    loading,
    error,
    cargarRoles,
    actualizarPermisos,
    setError
  };
};
